<template lang="html">
  <el-dialog
    v-if="dialogVisible"
    class="flowing-water-dialog"
    title="流水详情"
    width="700px"
    :visible="dialogVisible"
    @close="close"
  >
    <div class="flowing-water-detail-wrapper">
      <div class="flowing-water-content">
        <div class="flowing-item">
          <span>承运方：</span>
          <span>{{ details.carrier }}</span>
        </div>
        <div class="flowing-item">
          <span>流水号：</span>
          <span>{{ details.runningNo }}</span>
        </div>
        <div class="flowing-item">
          <span>账单号：</span>
          <span class="link-url" @click="goBillDetail">{{
            details.billNo
          }}</span>
        </div>
        <div class="flowing-item">
          <span>收付类型：</span>
          <span>{{ details.receiptAndPaymentType }}</span>
        </div>
        <div class="flowing-item">
          <span>收款方式：</span>
          <span>{{
            {
              1: "油卡",
              2: "网银",
              3: "现金",
              4: "支付宝",
              5: "微信",
              6: "电汇",
              7: "支票",
              8: "承兑"
            }[details.method]
          }}</span>
        </div>
        <div class="flowing-item">
          <span>金额：</span>
          <span>{{ details.totalMoney }}</span>
        </div>
        <div class="flowing-item">
          <span>生成时间：</span>
          <span>{{ details.createTime | timeFormat }}</span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">投诉</el-button>
    </span>
    <!-- 投诉弹窗 -->
    <complaint-dialog
      :dialogVisible.sync="complaintVisible"
      :content="details.runningNo"
      @close="close"
    />
  </el-dialog>
</template>

<script>
import complaintDialog from "./components/complaintDialog";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    details: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      complaintVisible: false
    };
  },
  computed: {},
  created() {},
  methods: {
    close() {
      this.$emit("update:dialogVisible", false);
    },
    goBillDetail() {
      this.$router.push({
        name: "billDetail",
        params: {
          billNo: this.details.billNo
        }
      });
    },
    submit() {
      this.complaintVisible = true;
    }
  },
  watch: {},
  components: {
    complaintDialog
  }
};
</script>

<style lang="scss" scoped>
.flowing-water-detail-wrapper {
  .flowing-water-content {
    border: 1px solid #e0e0e0;
    padding: 20px 40px;
    display: flex;
    flex-wrap: wrap;
    line-height: 30px;
    .flowing-item {
      width: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/flowingWater/components/flowingWaterTable/components/detailDialog/index.vue